export default __webpack_public_path__ + "static/media/Chhattisgarhi_df_1.a420e93b.mp3";